
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/base",
      function () {
        return require("private-next-pages/base.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/base"])
      });
    }
  